import { Link } from "react-router-dom";
import DrGray from "./team/DrGray";
import NurseHayley from "./team/NurseHayley";
import AestheticianTaylor from "./team/AestheticianTaylor";

const About = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-serif text-center mb-12">About Us</h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <DrGray />
          <div className="space-y-6">
            <NurseHayley />
            <AestheticianTaylor />
            <Link
              to="/about"
              className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors"
            >
              Learn More About Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;